var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-bottom"},[_c('div',{staticClass:"cn"},[_vm._v("珠海市京美心理测量技术开发有限公司")]),_c('div',{staticClass:"en"},[_vm._v("KING MAY PSYCHOLOGICAL ASSESSMENT TECHNOLOGY DEVELOPMENT LTD.")])])
}]

export { render, staticRenderFns }